import CancelConfirmationDialog from './cancel_confirmation_dialog';

export default CancelConfirmationDialog;
